import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

const SuccessPopup = ({ open, onClose, message }) => {
  const { t } = useTranslation();
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          margin: { xs: "1rem", sm: "2rem" },
          width: { xs: "90%", sm: "380px" },
          maxWidth: "380px",
          borderRadius: "12px",
          padding: 0,
        },
      }}
    >
      <DialogContent
        sx={{
          padding: 0,
          position: "relative",
          textAlign: "center",
        }}
      >
        {/* Close Icon - Top Right */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: "12px",
            right: "12px",
            color: "#666",
            zIndex: 1,
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Content Container */}
        <Box
          sx={{
            padding: "3rem .5rem .5rem .5rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          {/* Success Icon */}
          <CheckCircleIcon
            sx={{
              fontSize: { xs: "3rem", sm: "4rem" },
              color: "#4caf50",
              marginBottom: 1,
            }}
          />

          {/* Success Message */}
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "1rem", sm: "1.1rem" },
              color: "#333",
              textAlign: "center",
              lineHeight: 1.5,
              marginBottom: 2,
              padding:'1rem'
            }}
          >
            {message}
          </Typography>

          {/* Close Button */}
          <Button
            variant="contained"
            onClick={onClose}
            fullWidth
            sx={{
              backgroundColor: "#002560",
              color: "white",
              padding: { xs: "0.75rem", sm: "1rem" },
              fontSize: { xs: "0.9rem", sm: "1rem" },
              fontWeight: 500,
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#002155",
              },
            }}
          >
            {t('close')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessPopup;